var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ButtonUsers',{ref:"buttonUsers",attrs:{"weet":_vm.weet},on:{"click":function($event){_vm.popUpActive=true}}}),(_vm.weet)?_c('SharePanel',{attrs:{"weet":_vm.weet,"active":_vm.popUpActive},on:{"update:active":function($event){_vm.popUpActive=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }